<script setup>
import { Actions, EventManager } from "@events";
import VideoCallButton from "@/components/Common/VideoCallButton.vue";

import { useVideoCallState } from "@/stores/videoCallState";
import { computed } from "vue";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

const actionEmitter = EventManager.getActionEmitter(props.rtcId);
const state = useVideoCallState(props.rtcId);

function toggleMute() {
  actionEmitter.emit(
    state.remoteVideoMuted ? Actions.UnmuteRemoteVideo : Actions.MuteRemoteVideo
  );
}

const iconClass = computed(() => {
  if (state.remoteVideoMuted) {
    return "mdi-video-box-off";
  }
  return "mdi-video-box";
});
</script>
<template>
  <VideoCallButton
    :active="state.remoteVideoMuted"
    :icon="iconClass"
    @click="toggleMute"
    :disabled="state.disableVideoControls"
  ></VideoCallButton>
</template>

  